var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-y-transition',[(_vm.visible)?_c('RotatingLogo',{staticClass:"topdown elevation-10"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }